/* =====================================================================
   ALMA COLCHÕES — Oferta automática de almofada na compra de colchão
   =====================================================================
   O que este ficheiro faz:
   - Sempre que houver 1 ou mais "colchões" no carrinho, garante que existe
     2 almofadas (por colchão) adicionadas em silêncio ao carrinho, a 0€.
   - Essa almofada é um artigo real do carrinho, por isso segue para o
     checkout e aparece na fatura.
   - Mostra uma nota discreta dentro do próprio painel do carrinho
     (logo abaixo do cabeçalho "Carrinho"), a avisar da oferta — sem
     mostrar a almofada como linha separada no painel.
   ===================================================================== */

(function () {
  "use strict";

  /* ============ CONFIGURAÇÃO ============ */

  var GIFT_VARIANT_ID = 53424642294097;
  var QUALIFYING_PRODUCT_TYPES = ["colchão", "colchões", "mattress"];
  var QUALIFYING_HANDLES = [];
  var GIFT_QTY_PER_UNIT = 2;
  var NOTE_SUBTITLE = "Com o Colchão Alma One · adicionadas no checkout.";

  function buildNoteTitle(giftQty) {
    return giftQty + " Almofadas Conforel de oferta";
  }

  /* ======================================== */

  var nativeFetch = window.fetch.bind(window);
  var syncing = false;
  var pending = false;
  var lastGiftQty = -1;
  var drawerObserverAttached = false;

  function isQualifyingItem(item) {
    var type = (item.product_type || "").toLowerCase().trim();
    var handle = (item.handle || "").toLowerCase().trim();
    if (QUALIFYING_PRODUCT_TYPES.indexOf(type) !== -1) return true;
    if (QUALIFYING_HANDLES.indexOf(handle) !== -1) return true;
    return false;
  }

  function getCart() {
    return nativeFetch("/cart.js").then(function (r) {
      return r.json();
    });
  }

  function setGiftQuantity(lineKey, quantity) {
    return nativeFetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    }).then(function (r) {
      return r.json();
    });
  }

  function addGift(quantity) {
    return nativeFetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: quantity }],
      }),
    }).then(function (r) {
      return r.json();
    });
  }

  /* ---------- Nota dentro do painel do carrinho (cart-drawer) ---------- */

  function findDrawer() {
    return document.querySelector("cart-drawer");
  }

  function attachDrawerObserver(drawer) {
    if (drawerObserverAttached || !drawer) return;
    drawerObserverAttached = true;
    var observer = new MutationObserver(function () {
      renderDrawerNote(lastGiftQty);
    });
    // Observa o próprio elemento (DOM normal, não o shadow root —
    // os itens do carrinho são "slotted", ou seja, DOM normal).
    observer.observe(drawer, { childList: true, subtree: true });
    if (drawer.shadowRoot) {
      observer.observe(drawer.shadowRoot, { childList: true, subtree: true });
    }
  }

  function hideGiftLineItems(drawer) {
    var items = drawer.querySelectorAll("line-item");
    items.forEach(function (li) {
      var link = li.querySelector('a[href*="variant="]');
      var isGift =
        link && link.href.indexOf("variant=" + GIFT_VARIANT_ID) !== -1;
      li.style.display = isGift ? "none" : "";
    });
  }

  function renderDrawerNote(giftQty) {
    var drawer = findDrawer();
    if (!drawer) return;

    attachDrawerObserver(drawer);
    hideGiftLineItems(drawer);

    // Tenta primeiro no DOM normal (slotted); se não encontrar,
    // tenta dentro do shadow root como alternativa.
    var itemsContainer = drawer.querySelector(".cart-drawer__items");
    var searchRoot = drawer;
    if (!itemsContainer && drawer.shadowRoot) {
      itemsContainer = drawer.shadowRoot.querySelector(".cart-drawer__items");
      searchRoot = drawer.shadowRoot;
    }
    if (!itemsContainer || !itemsContainer.parentNode) return;

    var note = searchRoot.querySelector
      ? searchRoot.querySelector("#oferta-almofada-nota")
      : null;
    var noteTitle = giftQty > 0 ? buildNoteTitle(giftQty) : null;
    var desiredText = noteTitle !== null ? noteTitle + NOTE_SUBTITLE : null;

    if (desiredText === null) {
      if (note) note.remove();
      return;
    }

    if (note && note.textContent === desiredText) {
      return; // já está correto, não voltar a tocar (evita loop com o observer)
    }

    if (!note) {
      note = document.createElement("div");
      note.id = "oferta-almofada-nota";
      note.style.cssText =
        "margin:16px 0;padding:12px 16px;letter-spacing:.01em;" +
        "text-align:left;background:#F7F6F4;border:1px solid #E7E3DD;";
      itemsContainer.parentNode.insertBefore(note, itemsContainer);
    }
    note.innerHTML =
      '<div style="font-size:13px;font-weight:600;line-height:1.35;color:#3b2418;">' +
      noteTitle +
      "</div>" +
      '<div style="margin-top:3px;font-size:12px;line-height:1.35;color:#8a8378;">' +
      NOTE_SUBTITLE +
      "</div>";
  }

  /* ----------------------------------------------------------------------- */

  function sync() {
    if (syncing) {
      pending = true;
      return;
    }

    if (!GIFT_VARIANT_ID || GIFT_VARIANT_ID === 1234567890123) {
      console.warn(
        "[Oferta Almofada] Configura o GIFT_VARIANT_ID no topo de gift-with-purchase.js antes de usar."
      );
      return;
    }

    syncing = true;

    getCart()
      .then(function (cart) {
        var mattressQty = 0;
        var giftLine = null;

        cart.items.forEach(function (item) {
          if (isQualifyingItem(item)) {
            mattressQty += item.quantity;
          }
          if (item.variant_id === GIFT_VARIANT_ID) {
            giftLine = item;
          }
        });

        var targetGiftQty = mattressQty * GIFT_QTY_PER_UNIT;
        var currentGiftQty = giftLine ? giftLine.quantity : 0;

        lastGiftQty = targetGiftQty;
        renderDrawerNote(targetGiftQty);

        if (targetGiftQty === currentGiftQty) {
          return null;
        }
        if (targetGiftQty > 0 && !giftLine) {
          return addGift(targetGiftQty);
        }
        if (giftLine) {
          return setGiftQuantity(giftLine.key, targetGiftQty);
        }
        return null;
      })
      .catch(function (err) {
        console.error("[Oferta Almofada] Erro ao sincronizar o carrinho:", err);
      })
      .then(function () {
        syncing = false;
        if (pending) {
          pending = false;
          sync();
        }
      });
  }

  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(sync, 0);
  } else {
    document.addEventListener("DOMContentLoaded", sync);
  }

  // Rede de segurança: verifica o carrinho a cada 1.5 segundos.
  setInterval(sync, 1500);

  // Reage a qualquer clique (cobre botões "Adicionar ao carrinho"
  // que o tema possa esconder das chamadas de rede).
  document.addEventListener(
    "click",
    function () {
      setTimeout(sync, 500);
    },
    true
  );

  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    return nativeFetch(input, init).then(function (response) {
      if (isCartMutation) {
        setTimeout(sync, 350);
      }
      return response;
    });
  };

  var nativeXHROpen = XMLHttpRequest.prototype.open;
  var nativeXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(
      url || ""
    );
    return nativeXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__isCartMutation) {
      this.addEventListener("loadend", function () {
        setTimeout(sync, 350);
      });
    }
    return nativeXHRSend.apply(this, arguments);
  };
})();